import { Box, useMediaQuery } from "@mui/material";
import imgBannerOficinaCidada from "../../../../assets/images/banner-oficina.png";
import imgBannerDesenvolvimentoPessoas from "../../../../assets/images/empresa/pessoas/PESSOAS_conhecimento_que_transforma.png";
import imgCosturandoVidasSonhos from "../../../../assets/images/costurando-vidas-e-sonhos.png";
import imgOficinaCidada from "../../../../assets/images/oficina-cidada.png";
import imgRegrasDeOuro from "../../../../assets/images/empresa/pessoas/PESSOAS_regras_de_ouro.png";
import MidiaTextBanner from "../../../../components/layout/midia-text-banner";
import DefaultText from "../../../../components/typography/default-text";
import styles from "./styles.module.css";
const Pessoas: React.FC = () => {

  const isDisplayMedium = useMediaQuery('(max-width: 1200px)');

  const isMobile = useMediaQuery("(max-width: 899px)");

  const descriptionDesktop = `
    O Atenna é o hub de desenvolvimento da 
    Telemont, criado para impulsionar o 
    crescimento e a capacitação contínua das 
    nossas pessoas. Com uma abordagem voltada à 
    evolução e ao futuro, o hub oferece uma ampla 
    variedade de cursos, treinamentos e programas 
    que fortalecem o desenvolvimento profissional e 
    estimulam a transformação cultural dentro da 
    empresa.
  `;

  const descriptionMobile = `
    O Atenna é o hub de desenvolvimento
    da Telemont, criado para impulsionar o 
    crescimento e a capacitação contínua 
    das nossas pessoas. Com uma 
    abordagem voltada à evolução e ao 
    futuro, o hub oferece uma ampla 
    variedade de cursos, treinamentos e 
    programas que fortalecem o 
    desenvolvimento profissional e 
    estimulam a transformação cultural 
    dentro da empresa.
  `;

  const description = isMobile ? descriptionMobile : descriptionDesktop;

  const oficinaCidadaTitleDesktop = "UMA TELEMONT FEITA PARA TODOS";
  const oficinaCidadaTitleMobile = (
    <>
      UMA TELEMONT <br /> FEITA PARA TODOS
    </>
  );

  const redirectExternalLik = (link: string) => {
    window.open(link, '_blank');
  }

  return (
    <>
      <Box width={'100%'} marginTop={'48px'}>
        <MidiaTextBanner headingRegular="Conhecimento" headingBold="que transforma"
          description={description}
          buttonText="Faça Parte" image={imgBannerDesenvolvimentoPessoas}
          onButtonClick={() => { redirectExternalLik('https://telemont.gupy.io/') }}
        />
      </Box>
      <div className={styles["sub-page-content-grey"]}>
        <div className={styles["oficina-cidada-banner-container"]}>
          <div className={styles["banner-text-content"]}>
            <DefaultText sx={{ letterSpacing: "2px", fontSize: "20px" }}>
              {isMobile ? oficinaCidadaTitleMobile : oficinaCidadaTitleDesktop}
            </DefaultText>
            <div>
              <DefaultText sx={{ fontFamily: 'Montserrat-Regular' }}>
                Costurando
              </DefaultText>
              <DefaultText sx={{ fontFamily: 'Montserrat-Bold' }}>
                <i>vidas e sonhos</i>
              </DefaultText>
            </div>
            <DefaultText size="small" maxWidth={isDisplayMedium ? "unset" : "1000px"}>
              A Oficina Cidadã Telemont foi inaugurada em 2017, em <span className={styles["desktop-break"]}></span>
              Belo Horizonte (MG), com o propósito de promover <span className={styles["desktop-break"]}></span>
              inclusão social e geração de oportunidades para pessoas <span className={styles["desktop-break"]}></span>
              com deficiência. O espaço foi projetado para garantir <span className={styles["desktop-break"]}></span>
              acessibilidade e acolhimento, oferecendo condições <span className={styles["desktop-break"]}></span>
              adequadas de trabalho e valorizando a diversidade <span className={styles["desktop-break"]}></span> 
              como parte essencial da cultura organizacional da <span className={styles["desktop-break"]}></span> 
              empresa. Na oficina, os colaboradores produzem <span className={styles["desktop-break"]}></span> 
              uniformes e acessórios utilizados por equipes da própria <span className={styles["desktop-break"]}></span> 
              Telemont, fortalecendo o senso de pertencimento e <span className={styles["desktop-break"]}></span>
              contribuindo diretamente para as operações da <span className={styles["desktop-break"]}></span>
              companhia.
              <br /><br />
              Ao longo dos anos, a iniciativa se consolidou como uma <span className={styles["desktop-break"]}></span> 
              referência nacional em práticas inclusivas e <span className={styles["desktop-break"]}></span> 
              responsabilidade social, sendo reconhecida pelo Prêmio <span className={styles["desktop-break"]}></span> 
              Ser Humano da ABRH-MG, um dos mais importantes do <span className={styles["desktop-break"]}></span> 
              setor de gestão de pessoas. Esse reconhecimento <span className={styles["desktop-break"]}></span>
              reforça o compromisso da Telemont em transformar <span className={styles["desktop-break"]}></span>
              vidas por meio do trabalho, da capacitação e do respeito <span className={styles["desktop-break"]}></span> 
              às diferenças, princípios que continuam a orientar a <span className={styles["desktop-break"]}></span> 
              expansão do projeto para outras localidades do país.
            </DefaultText>
          </div>
          <div className={styles["banner-images-container"]}>
            {isMobile ? (
              <>
                <img src={imgBannerOficinaCidada} alt="Imagem ilustrativa oficina cidadã" className={styles["banner-image"]} />
                <img src={imgOficinaCidada} alt="Logo oficina cidadã Telemont" className={styles["banner-image"]} style={{ maxWidth: '370px' }} />
              </>
            ) : (
              <>
                <img src={imgOficinaCidada} alt="Logo oficina cidadã Telemont" className={styles["banner-image"]} style={{ maxWidth: '370px' }} />
                <img src={imgBannerOficinaCidada} alt="Imagem ilustrativa oficina cidadã" className={styles["banner-image"]} />
              </>
            )}
          </div>
        </div>
        <div className={styles["costurando-banner-container"]}>
          <div className={styles["costurando-container"]}>
            <img src={imgCosturandoVidasSonhos} alt="Costurando vidas e sonhos" className={styles["costurando-image"]} />
          </div>
          <div className={styles["banner-text-content-inferior"]}>
            <DefaultText size="small" maxWidth={isDisplayMedium ? "unset" : "700px"}>
              Além da Oficina Cidadã, a Telemont, por meio das <span className={styles["desktop-break"]}></span> 
              Leis de Incentivo à Cultura, Esporte e do <span className={styles["desktop-break"]}></span> 
              Audiovisual, contribui para o fomento do lazer e <span className={styles["desktop-break"]}></span> 
              bem-estar social de milhares de pessoas em todo o <span className={styles["desktop-break"]}></span> 
              Brasil. Essa ação estimula a produção cultural, <span className={styles["desktop-break"]}></span> 
              artística e esportiva, permitindo o acesso e a <span className={styles["desktop-break"]}></span> 
              inclusão da população em diversos benefícios <span className={styles["desktop-break"]}></span> 
              socioculturais.
            </DefaultText>
          </div>
        </div>
      </div>
      <div className={styles["sub-page-content"]}>
        <div className={styles["banner-container"]}>
          <img src={imgRegrasDeOuro} alt="Imagem descritivo Regras de Ouro" className={styles["banner-image-regras-ouro"]} style={{ maxWidth: '375px' }} />
          <div className={styles["banner-text-content"]}>
            <DefaultText 
              sx={{fontFamily: 'Montserrat-Regular', fontSize: isMobile ? '25px' : '32px', marginBottom: '-30px', lineHeight: '1.2'}}>
              Regras de Ouro
            </DefaultText>
            <DefaultText sx={{fontFamily: 'Montserrat-Bold', fontSize: isMobile ? '25px' : '32px', lineHeight: '1.2'}}>
              <i>segurança sempre!</i>
            </DefaultText>
            {!isMobile && (
                <DefaultText size="small" maxWidth={"700px"}>
                  Na Telemont, a segurança é um princípio inquestionável.
                  Oferecer as melhores condições de trabalho é um compromisso que temos com todos os nossos colaboradores, parceiros e clientes.
                  Para promover a cultura de segurança, consolidamos em um conjunto de regras os procedimentos e protocolos necessários para operar de forma segura:
                  são as nossas Regras de Ouro.
                  <br/> <br/>
                  Além disso, realizamos campanhas e auditorias periodicamente para manter ativa a responsabilidade e o cuidado com a saúde ocupacional, a
                  segurança operacional e a preservação do meio ambiente.
                </DefaultText>
            )}
            {isMobile && (
                <DefaultText size="small" maxWidth={"700px"}>
                    Na Telemont, a segurança é um <br/> princípio inquestionável. <br/>
                    Oferecer as melhores <br/> 
                    condições de trabalho é um <br/> 
                    compromisso que temos com <br/> 
                    todos os nossos colaboradores,<br/> parceiros e clientes. Para <br/> 
                    promover a cultura de <br/> 
                    segurança, consolidamos em <br/>
                    um conjunto de regras os <br/> 
                    procedimentos e protocolos <br/>
                    necessários para operar de <br/>
                    forma segura: são as nossas <br/> 
                    Regras de Ouro.
                    <br/> <br/>
                    Além disso, realizamos <br/> 
                    campanhas e auditorias <br/>
                    periodicamente para manter <br/> 
                    ativa a responsabilidade e o <br/>
                    cuidado com a saúde <br/>
                    ocupacional, a segurança <br/>
                    operacional e a preservação do <br/>
                    meio ambiente.
                </DefaultText>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Pessoas;